module.exports = __webpack_public_path__ + "static/media/paintathon-bg.d64c0041.jpg";